"use client";

import { Alert, AlertDescription } from "ui/components/alert";
import { AlertCircle, RefreshCw } from "lucide-react";

import { Button } from "ui/components/button";
import { EvtSectionHeader } from "components/header";
import NestedProgressChart from "components/nested-bar-chart";
import { Skeleton } from "ui/components/skeleton";
import { useJobHours } from "components/job/burn-chart/useJobHours";
import { useMilestoneHours } from "components/job/burn-chart/useMilestoneHours";

function Loader() {
  return (
    <div className="container mx-auto p-6 space-y-6">
      <Skeleton className="h-20 w-full" />
    </div>
  );
}

function Error() {
  return (
    <div className="p-6">
      <Alert variant="destructive">
        <AlertCircle className="h-4 w-4" />
        <AlertDescription className="flex items-center justify-between">
          <span>Error loading job data: {error}</span>
          <Button
            variant="outline"
            size="sm"
            onClick={refetch}
            className="ml-4"
          >
            <RefreshCw className="h-4 w-4 mr-2" />
            Retry
          </Button>
        </AlertDescription>
      </Alert>
    </div>
  );
}

export function BurnChart({ id, name, index = 0 }) {
  const { data, loading, error, refetch } = useJobHours({ id, name });

  if (loading) {
    return <Loader />;
  }

  if (error) {
    return <Error />;
  }

  return (
    <NestedProgressChart
      data={[data]}
      index={index}
      title="Project Hours Comparison"
      showLabel={true}
    />
  );
}

export function MilestoneBurnChart({ id, name, index = 0 }) {
  const { data, loading, error, refetch } = useMilestoneHours({ id, name });

  if (loading) {
    return <Loader />;
  }

  if (error) {
    return <Error />;
  }

  return (
    <NestedProgressChart
      data={[data]}
      index={index}
      title="Project Hours Comparison"
      showLabel={true}
      showAllocatedHours={false}
    />
  );
}
